import React, { useEffect, useState } from 'react'
import Glass from '@ui/elements/Glass/Glass'
import Popover from '@ui/components/Popover'
import PressableIcon from '@ui/buttons/PressableIcon'
import { useSharedValue } from 'react-native-reanimated'
import Button from '@ui/buttons/Button'

import { DropdownProps } from './types'
import Item from './Item'
import cn from '@ui/utils/cn'
import useAnimatedToggle from '@ui/hooks/useAnimatedToggle'
import { colors } from '@ui/colors'
import { Platform } from 'react-native'

export default function Dropdown({
  icon,
  button,
  items,
  popoverProps,
  classNameGlass,
  styleGlass = {},
  offsetX = 1,
  width = 300,
  ...props
}: DropdownProps) {
  const [open, setOpenLocal] = useState(props.open || false)
  const animation = useAnimatedToggle(open)
  const customWidth = useSharedValue(width)

  const setOpen = (open: boolean) => {
    setOpenLocal(open)
    props.setOpen?.(open)
  }

  const toggle = () => {
    setOpen(!open)
  }

  const makePress = (cb?: () => void) => {
    return () => {
      cb?.()
      setOpen(false)
    }
  }

  useEffect(() => {
    if (props.open !== undefined) {
      setOpenLocal(props.open)
    }
  }, [props.open])

  useEffect(() => {
    customWidth.value = width
  }, [width])

  return (
    <Popover
      offset={8}
      position={['bottom', 'right']}
      {...popoverProps}
      customWidth={customWidth}
      content={
        <Glass
          blur={100}
          tint="light"
          className={cn('p-0', classNameGlass)}
          border={{
            borderRadius: 16,
            borderColor: colors.black10,
            borderWidth: 1,
          }}
          style={[
            {
              backgroundColor: Platform.select({
                default: colors.white75,
                web: colors.white50,
              }),
              transform: [{ translateX: offsetX }, { translateY: 0 }],
              width,
            },
            styleGlass,
          ]}
          gradient={[colors.white0, colors.white0]}
        >
          {items
            ?.filter(({ hidden }) => !hidden)
            .map((item, index) => (
              <Item
                {...item}
                key={item.key ?? index.toString()}
                onPress={makePress(item.onPress)}
                index={index}
              />
            ))}
          {/* TODO: render children here as react clone element and pass onPress to it */}
        </Glass>
      }
      open={open}
      onClose={() => setOpen(false)}
    >
      {button && <Button animation={animation} onPress={toggle} {...button} />}
      {icon && (
        <PressableIcon animation={animation} onPress={toggle} {...icon} />
      )}
    </Popover>
  )
}
